import React, { useEffect, useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import QualificationMatcher from "../components/QualificationMatcher";
import { CUSTOMER_EDITABLE_STATUSES, UserType, WorkOrderStatusType } from "../../../utils/enum";
import EditQualificationModal from "../components/EditQualificationModal";

const Qualification = ({
  qualifications,
  authRole,
  createdById,
  authUserId,
  setIsEdit,
  hasUpdateAccess,
  currentStatus,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Customers may set eligibility on their own work orders, within the window
  // they can edit anything at all (Draft, Submitted, Accepted). Clients keep
  // their existing window, which runs to ROUTED but has no Submitted state.
  const canEditEligibility =
    hasUpdateAccess &&
    (authRole === UserType?.CUSTOMER
      ? CUSTOMER_EDITABLE_STATUSES.includes(currentStatus)
      : authRole === UserType?.CLIENT &&
        [
          WorkOrderStatusType.DRAFT,
          WorkOrderStatusType.PUBLISHED,
          WorkOrderStatusType.ROUTED,
        ].includes(currentStatus));

  return (
    <BaseCard className="pt-4 pb-6 xl:px-16 px-5 rounded-lg !mb-[0px] h-full" elevation={1}>
      <div className="border-bottom mb-4 flex items-center pb-1">
        <h6 className="text-dark">Work Order Eligibility</h6>
        {canEditEligibility && (
          <i
            className="fa-light fa-pencil text-gray-900 ml-3 cursor-pointer"
            onClick={() => {
              setIsModalOpen(true);
              setIsEdit(true);
            }}
          ></i>
        )}
      </div>
      {qualifications?.length > 0 && (
        <QualificationMatcher workOrderQualifications={qualifications} />
      )}
      {isModalOpen && (
        <EditQualificationModal
          open={isModalOpen}
          close={() => setIsModalOpen(false)}
          createdById={createdById}
          authUserId={authUserId}
        />
      )}
    </BaseCard>
  );
};

export default Qualification;
